import React, { useMemo } from "react";
import { Link } from "react-router-dom";

function TimelineItem({ booking, index }) {
  const date = new Date(booking.bookedAt);
  const timeStr = date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
  const dateStr = date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

  return (
    <div className="timeline-item" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="timeline-left">
        <div className="tl-time">{timeStr}</div>
        <div className="tl-date">{dateStr}</div>
      </div>
      <div className="timeline-connector">
        <div className="tl-dot" />
        {index !== 0 && <div className="tl-line" />}
      </div>
      <div className="timeline-body">
        <div className="tl-header">
          <span className="tl-ref">{booking.ref}</span>
          <span className="tl-status">Confirmed</span>
        </div>
        <div className="tl-route">
          <span className="tl-code">{booking.fromCode}</span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--accent-light)" strokeWidth="2">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
          <span className="tl-code">{booking.toCode}</span>
          <span className="tl-sep">·</span>
          <span className="tl-airline">{booking.airline}</span>
          <span className="tl-sep">·</span>
          <span className="tl-dur">{booking.duration}</span>
        </div>
        <div className="tl-footer">
          <span className="tl-pax">{booking.passenger.name}</span>
          <span className="tl-price mono">₹{booking.total.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}

function History({ bookings }) {
  const totalSpent = useMemo(
    () => bookings.reduce((s, b) => s + b.total, 0),
    [bookings]
  );
  const airlines = useMemo(
    () => [...new Set(bookings.map((b) => b.airline))],
    [bookings]
  );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-h1">Booking History</h1>
          <p className="page-desc">A complete timeline of your travel activity.</p>
        </div>
      </div>

      {bookings.length > 0 && (
        <div className="history-stats">
          <div className="hst-card">
            <div className="hst-val">{bookings.length}</div>
            <div className="hst-label">Total Flights</div>
          </div>
          <div className="hst-card">
            <div className="hst-val mono">₹{totalSpent.toLocaleString()}</div>
            <div className="hst-label">Total Spent</div>
          </div>
          <div className="hst-card">
            <div className="hst-val">{airlines.length}</div>
            <div className="hst-label">Airlines Used</div>
          </div>
          <div className="hst-card">
            <div className="hst-val">
              {bookings.length > 0
                ? Math.round(
                    bookings.reduce((s, b) => s + b.price, 0) / bookings.length
                  ).toLocaleString()
                : "—"}
            </div>
            <div className="hst-label">Avg. Fare (₹)</div>
          </div>
        </div>
      )}

      {bookings.length === 0 ? (
        <div className="page-empty">
          <div className="page-empty-icon">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
          </div>
          <h3 className="page-empty-title">No history yet</h3>
          <p className="page-empty-sub">Your booking timeline will appear here once you confirm a flight.</p>
          <Link to="/" className="page-empty-cta">Book a Flight →</Link>
        </div>
      ) : (
        <div className="timeline">
          {bookings.map((b, i) => (
            <TimelineItem key={b.ref} booking={b} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}

export default History;